import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CollectionFolderViewerComponent } from './collection-folder-viewer.component';
import { CollectionItemViewerModule } from '../collection-item-viewer/collection-item-viewer.module';
import { SearchPipeModule } from '@go-modules/pipes/search/search.pipe.module';
import { SearchPipe } from '@go-modules/pipes/search/search.pipe';
import { SortPipeModule } from '@go-modules/pipes/sort/sort.pipe.module';
import { ManageLibraryCollectionFolderModule } from '../manage-library-collection-folder/manage-library-collection-folder.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		CollectionItemViewerModule,
		SortPipeModule,
		SearchPipeModule,
		ManageLibraryCollectionFolderModule,
		MatProgressBarModule
	],
	declarations: [
		CollectionFolderViewerComponent
	],
	exports: [
		CollectionFolderViewerComponent
	],
	providers: [
		SearchPipe
	]
})
export class CollectionFolderViewerModule {}
